<div class="bc-chat-box bc-panel" [attr.data-automation-id]="'bc-chat-box'">
  <div *ngIf="chat.ChatID" class="chat-panel">
    <div class="bc-chat-content">
      <div class="bc-content-inner column-flex-container" *ngIf="!isTransferPanelActive">

        <div class="chat-header bc-panel-header">
          <div class="chat-title bc-panel-header-text">
              <span class="chat-title-icon">
              <svg-icon icon="chat-outline" class="bc-panel-header-icon"></svg-icon>
              </span>
            <span class="chat-title-text">{{ 'bcChatBox.chat' | translate }}</span>
          </div>
          <div class="chat-info">
            <div *ngIf="chat.InvitationTemplateVariantID">
              {{ 'bcChatBox.proactive' | translate }}
            </div>
            <div *ngIf="chatAssignmentInfo" class="assignment-details">
              <div>{{ transferType | translate }}
                <span class="assignment-source" [attr.data-automation-id]="'bc-assignment-source'">{{ chatAssignmentInfo.assignedFrom }}</span>
              </div>
              <div>{{ 'bcChatBox.at' | translate }}
                <span class="assignment-date">{{ this.formattedAssignmentDate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="scroll-bottom-list panel-body chat-box-messages column-flex-grow" [ngClass]="{ 'bc-wrapup-open': isWrapupPanelActive, 'bc-chat-inactive': !isChatActive() }">
          <app-visitor-history *ngIf="!isExpandedMode()"
                               [chatId]="chat.ChatID"
                               [showOldestFirst]="true"
                               (loaded)="onVisitorHistoryLoaded()"></app-visitor-history>

          <app-chat-messages [messages]="messages"
                         [isActive]="isChatActive()"
                         [workItemId]="chat.ChatID"
                         [workItemCreated]="chat.Created"
                         [workItemType]="workItem.type"
                         [hasActiveRemoteControl]="workItem.hasActiveRemoteControl"
                         [canAgentProposeArticle]="canAgentProposeArticle()"></app-chat-messages>
          <app-loading *ngIf="areWrapupsLoading()"></app-loading>

          <app-wrap-up-panel *ngIf="haveWrapupsLoaded() && !hideWrapUpPanel"
                           [workItemId]="chat.ChatID"
                           [isEnded]="chat.isEnded()"
                           [isClosed]="chat.isClosed()"
                           [type]="workItem.type"
                           [rawWrapups]="wrapups"
                           (wrapUpChange)="onWrapUpChange($event)"
                           (togglePanel)="toggleWrapupPanel()"></app-wrap-up-panel>
        </div>

        <app-chat-actions *ngIf="isChatActive()"
                          class="column-flex-fix"
                          [isChatInProgress]="isChatInProgress()"
                          [isAnswerable]="isAnswerable()"
                          [isDisconnected]="isDisconnected()"
                          [isWrapUpPanelActive]="isWrapupPanelActive"
                          [chatId]="chat.ChatID"
                          [messages]="messages"
                          [visitorName]="chat.ChatName"
                          (answerChat)="answerChat()"></app-chat-actions>

        <app-join-chat *ngIf="isExpandedMode() && canJoinChat" [chatId]="chat.ChatID" (joinStateChanged)="onJoinStateChange($event)"></app-join-chat>

        <div class="column-flex-fix" *ngIf="isChatInProgress() && isFocused()" class="send-message-control">

          <app-file-upload-box [workItemId]="workItem.id"></app-file-upload-box>

          <app-pending-messages [workItemId]="workItem.id"></app-pending-messages>

          <app-alert-box [editorMessages]="editorMessages.messages" (closeHandler)="clearEditorMessage()"></app-alert-box>

          <div class="chat-panel-footer row no-margin work-widget-panel-footer">

            <a *ngIf="!isExpandedMode() && !isMoreActionsVisible"
               (click)="toggleCannedMessagePanel(false)"
               class="btn btn-borderless btn-cm">
              <svg-icon icon="can-outline"></svg-icon>
            </a>

            <a *ngIf="!isExpandedMode() && !isMoreActionsVisible && isNanorepVisible"
               (click)="toggleCannedMessagePanel(true)"
               class="btn btn-borderless btn-cm btn-sa">
              <svg-icon icon="smart-advisor"></svg-icon>
            </a>

            <app-editor #editorComponent *ngIf="!isMoreActionsVisible || isExpandedMode()"
                        [workItemType]="workItem.type"
                        [editorInitSetting]="editorInitSetting"
                        [workItemId]="workItem.id"
                        [commandList]="editorCommandList"
                        [editorMessages]="editorMessages"
                        [showFileUpload]="isFileTransferForOperatorEnabled$ | async"
                        (onCommandSelected)="executeCommand($event)"
                        [(editorContentModel)]="message.text"
                        [cannedMessageRequest]="cannedMessageRequest"
                        [submitOnEnter]="true"
                        (onEditorSubmit)="onEditorSubmit($event)"
                        (editorSetupDone)="onEditorSetupDone($event)"
                        [editorDisabled]="editorDisabled"
                        [isAccessibilitySettingAvailable]="true"></app-editor>

            <app-chat-buttons
              *ngIf="isExpandedMode()"
              [hasDiscussionsFeature]="hasDiscussionsFeature"
              [hasBlockChatPermission]="hasBlockChatPermission"
              [hasFlagPermission]="hasFlagPermission"
              [hasWrapUps]="hasWrapUps()"
              [isEndable]="isEndable()"
              [isTransferButtonDisabled]="workItem.hasActiveAssistedSession"
              [isDiscussionOpened] = isDiscussionPanelOpened
              [workItemId]="chat.ChatID"
              [workItemFlaggedState]="chat.Flagged"
              (toggleWrapUpPanel)="toggleWrapupPanel()"
              (openTransferChatSettings)="openTransferChatSettings()"
              (endChat)="endOrShowConfirmation()"
              (blockChat)="showBlockConfirmation()"
              (startDiscussion)="openDiscussionPanel()"></app-chat-buttons>

            <div class="more-actions" *ngIf="!isExpandedMode()" [ngClass]="{ 'open': isMoreActionsVisible }">
              <svg-icon icon="ellipsis" class="more-actions-icon" (click)="toggleMoreActions()" *ngIf="!isMoreActionsVisible"></svg-icon>

              <div class="flag-container" *ngIf="!isMoreActionsVisible">
                <app-flag [workItemId]="chat.ChatID" [workItemFlagState]="chat.Flagged"></app-flag>
              </div>

              <app-chat-more-actions
                *ngIf="isMoreActionsVisible"
                [hasWrapUps]="hasWrapUps()"
                (wrapUp)="toggleWrapupPanel()"
                (transfer)="openTransferChatSettings()"
                (endChat)="endOrShowConfirmation()"
                (togglePanel)="toggleMoreActions()"></app-chat-more-actions>
            </div>

            <app-smart-responses
              *ngIf="isSmartResponseEnabled()"
              [isSmartResponsesActive]="isSmartResponsesActive"
              [hasDiscussionsFeature]="hasDiscussionsFeature"
              (smartResponseSelected)="smartResponseSelected($event)"
              (setFocusOnEditor)="setFocusOnEditor()"
              (smartResponsesClosed)="closeSmartResponsePanel()"
              [record]="chat"></app-smart-responses>
          </div>
        </div>
      </div>
      <div class="bc-content-inner" *ngIf="isTransferPanelActive && isChatActive()">
        <app-transfer-panel (backButtonAction)="closeTransferChatSettings()"
                           (successfulTransferAction)="closeTransferChatSettings()"
                           [workItemId]="workItem.id"
                           [workItemType]="workItem.type"></app-transfer-panel>
      </div>
      <app-confirmation-modal
        #endConfirmationModal
        *ngIf="!isConfirmationModalDisabled() && confirmationVisible"
        (cancel)="closeConfirmation()"
        (confirm)="endChat()"
        (secondaryAction)="endChatAndDontShowModal()"
        [config] = confirmationBoxConfig></app-confirmation-modal>
      <app-confirmation-modal
        #blockConfirmationModal
        *ngIf="blockConfirmationVisible"
        (cancel)="closeBlockConfirmation()"
        (confirm)="blockChat()"
        [config] = blockConfirmationBoxConfig></app-confirmation-modal>
      <app-confirmation-modal
        #videoAutoStartConfirmationModal
        *ngIf="videoAutoStartConfirmationModalVisible"
        (confirm)="autoStartVideoCall()"
        (secondaryAction)="ignoreAutoStartVideo()"
        [attr.data-automation-id]="'bc-video-autostart-confirmation-modal'"
        [config]=videoAutoStartConfirmationConfig></app-confirmation-modal>
      <app-confirmation-modal
        #videoWithAcdConfirmationModal
        *ngIf="videoWithAcdConfirmationModalVisible"
        (confirm)="enforceAutoStartVideoCall()"
        (secondaryAction)="ignoreAutoStartVideo()"
        [attr.data-automation-id]="'bc-video-with-acd-confirmation-modal'"
        [config]=videoWithAcdConfirmationConfig></app-confirmation-modal>
      <app-confirmation-modal
        #videoConfirmationModal
        *ngIf="videoConfirmationModalVisible"
        (confirm)="enforceStartVideoCall()"
        (secondaryAction)="cancelStartVideoCall()"
        [attr.data-automation-id]="'bc-video-confirmation-modal'"
        [config]=videoConfirmationConfig></app-confirmation-modal>
      <app-confirmation-modal
        #cancelRemoteControlSessionConfirmationModal
        *ngIf="cancelRemoteControlSessionConfirmationModalVisible"
        (confirm)="cancelRemoteControlSession()"
        (secondaryAction)="continueRemoteControlSession()"
        [attr.data-automation-id]="'bc-cancel-remote-control-session-confirmation-modal'"
        [config]=cancelRemoteControlSessionConfirmationConfig></app-confirmation-modal>
      <app-auto-save [model]="message" [storageKey]="'chat-' + chat.ChatID" *ngIf="isChatActive()"></app-auto-save>
    </div>
  </div>
</div>
<div class="inactive-chat-panel-footer" [attr.data-automation-id]="'bc-inactive-chat-panel-footer'" *ngIf="!isFocused()">
  <app-inactive-widget-footer [text]="message.text"></app-inactive-widget-footer>
</div>
